<span class="{{ data.type }}" matSnackBarLabel> {{ data.message }} </span>
<span matSnackBarActions class="{{ data.type }}">
  <button
    mat-button
    matSnackBarAction
    (click)="snackBarRef.dismissWithAction()"
    style="color: black"
  >
    Chiudi
  </button>
</span>
